/* Noblete cart: instant free gifts, drawer refresh, terms check, wall preview, glue dots */
(function () {
  if (window.__pzCart) return;
  window.__pzCart = true;

  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var busy = false, again = false, failedAt = {}, lastFail = 0, lastApplied = 0, glueSet = false, timer = null;

  function $(s, r) { return (r || document).querySelector(s); }
  function drawerEl() { return $('cart-drawer'); }
  function post(u, b) {
    return fetch(u, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(b) });
  }

  // Everything the script needs is printed into the drawer by Liquid, so no extra /cart.js round trip is needed.
  function cfg() {
    var el = $('#pz-cart-cfg');
    if (!el) return null;
    var d = el.dataset;
    return {
      t1: +d.t1, t2: +d.t2, g1: +d.g1, g2: +d.g2,
      paid: +d.paid || 0, have1: +d.have1 || 0, have2: +d.have2 || 0,
      k1: d.k1 || '', k2: d.k2 || '', count: +d.count || 0, glue: d.glue || ''
    };
  }

  // Dawn only clears is-empty on .drawer__inner; the first item added to an empty cart left the drawer looking empty.
  function fixEmpty() {
    var d = drawerEl();
    if (!d) return;
    d.classList.toggle('is-empty', !d.querySelector('.pz-item'));
    if (Date.now() - lastFail < 20000) {
      d.querySelectorAll('[data-pz-pending]').forEach(function (n) { n.remove(); });
    }
  }

  // Backup checkout: if the PayPal buttons have not rendered a few seconds after the drawer content changes, show a normal checkout button.
  var expTimer = null;
  function checkExpress() {
    var fb = $('[data-pz-fallback]');
    if (!fb) return;
    var host = $('.pz-express__btns');
    var ok = !!(host && host.querySelector('iframe'));
    fb.hidden = ok;
  }
  function scheduleExpressCheck() {
    clearTimeout(expTimer);
    expTimer = setTimeout(checkExpress, 6000);
  }

  function applySections(s) {
    if (!s) return false;
    var d = drawerEl(), ok = false;
    if (s['cart-drawer'] && d) {
      var doc = new DOMParser().parseFromString(s['cart-drawer'], 'text/html');
      var src = doc.querySelector('.drawer__inner'), dst = $('#CartDrawer .drawer__inner');
      if (src && dst) { dst.innerHTML = src.innerHTML; ok = true; }
    }
    if (s['cart-icon-bubble']) {
      var b = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      var bubble = document.getElementById('cart-icon-bubble');
      if (b && bubble) bubble.innerHTML = b.innerHTML;
    }
    lastApplied = Date.now();
    fixEmpty();
    scheduleExpressCheck();
    return ok;
  }

  function refresh() {
    return fetch('/cart?sections=' + SECTIONS, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { applySections(j); })
      .catch(function () {});
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 80); }

  function sync() {
    var c = cfg();
    if (!c) return;
    if (busy) { again = true; return; }
    var add = [], rm = {}, now = Date.now();
    [[c.g1, c.have1, c.k1, c.t1], [c.g2, c.have2, c.k2, c.t2]].forEach(function (g) {
      var want = c.paid >= g[3] ? 1 : 0;
      if (want && g[1] === 0) {
        if (!failedAt[g[0]] || now - failedAt[g[0]] > 10000) add.push(g[0]);
      } else if (!want && g[1] > 0 && g[2]) rm[g[2]] = 0;
      else if (want && g[1] > 1 && g[2]) rm[g[2]] = 1;
    });
    var hasRm = Object.keys(rm).length > 0;
    var needGlue = c.count > 0 && !c.glue && !glueSet;

    if (!add.length && !hasRm) {
      if (needGlue) { glueSet = true; post('/cart/update.js', { attributes: { 'Free glue dots': 'Yes' } }).catch(function () {}); }
      return;
    }

    busy = true;
    window.__pzBusy = true;
    var url, body;
    if (hasRm) { url = '/cart/update.js'; body = { updates: rm, sections: SECTIONS }; }
    else {
      url = '/cart/add.js';
      body = { items: add.map(function (id) { return { id: id, quantity: 1, properties: { _gift: 'true' } }; }), sections: SECTIONS };
      window.__pzGiftAdding = true;
    }
    post(url, body)
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (res.ok && res.j && res.j.sections) applySections(res.j.sections);
        else if (res.ok) return refresh();
        else { add.forEach(function (id) { failedAt[id] = Date.now(); }); lastFail = Date.now(); fixEmpty(); }
      })
      .catch(function () { add.forEach(function (id) { failedAt[id] = Date.now(); }); lastFail = Date.now(); fixEmpty(); })
      .then(function () {
        window.__pzGiftAdding = false;
        busy = false;
        window.__pzBusy = false;
        if (needGlue) { glueSet = true; post('/cart/update.js', { attributes: { 'Free glue dots': 'Yes' } }).catch(function () {}); }
        if (again) { again = false; schedule(); }
      });
  }

  function watch() {
    var host = $('#CartDrawer');
    if (!host) return;
    new MutationObserver(function () { fixEmpty(); schedule(); }).observe(host, { childList: true, subtree: true });
  }

  window.pzOpenCart = function () {
    var d = drawerEl();
    if (!d) { location.href = '/cart'; return Promise.resolve(); }
    try { sessionStorage.removeItem('pz_open_cart'); } catch (e) {}
    window.__pzJustAdded = false;
    if (typeof d.open === 'function') d.open();
    if (window.__pzApplyP) return window.__pzApplyP;
    if (Date.now() - lastApplied < 5000) return Promise.resolve();
    return refresh();
  };

  // Builder / personalize pages call this after a successful add: open the drawer in place (no slow /cart page hop).
  window.pzAfterAdd = function (fallbackUrl) {
    var d = drawerEl();
    if (d && typeof d.open === 'function') return window.pzOpenCart();
    location.href = fallbackUrl || '/cart';
    return Promise.resolve();
  };

  // Gift lines the cart will need once `extraCents` of paid goods are added, so they can travel in the SAME add request.
  window.pzGiftItems = function (extraCents) {
    var c = cfg();
    if (!c) return [];
    var paid = c.paid + (extraCents || 0), out = [], now = Date.now();
    if (c.g1 && paid >= c.t1 && c.have1 === 0 && (!failedAt[c.g1] || now - failedAt[c.g1] > 10000)) out.push({ id: c.g1, quantity: 1, properties: { _gift: 'true' } });
    if (c.g2 && paid >= c.t2 && c.have2 === 0 && (!failedAt[c.g2] || now - failedAt[c.g2] > 10000)) out.push({ id: c.g2, quantity: 1, properties: { _gift: 'true' } });
    return out;
  };

  // One request for the main item(s) + any free gifts they unlock. If the gifts make it fail, retry without them.
  window.pzAddItems = function (items, extraCents) {
    var gifts = window.pzGiftItems(extraCents);
    function go(list) { return post('/cart/add.js', { items: list }); }
    return go(items.concat(gifts)).then(function (r) {
      if (!r.ok && gifts.length) { gifts.forEach(function (g) { failedAt[g.id] = Date.now(); }); return go(items); }
      return r;
    });
  };

  // Adds from builder pages / home cards: ask Shopify for the fresh drawer in the same request, then open it.
  var _f = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url) && init && /post/i.test(init.method || '') && !window.__pzGiftAdding && drawerEl();
    var injected = false;
    if (isAdd && typeof init.body === 'string' && init.body.charAt(0) === '{') {
      try {
        var o = JSON.parse(init.body);
        if (!o.sections) { o.sections = SECTIONS; init = Object.assign({}, init, { body: JSON.stringify(o) }); injected = true; }
      } catch (e) {}
    }
    var p = _f.call(this, input, init);
    if (isAdd) {
      var themeHandled = typeof FormData !== 'undefined' && init.body instanceof FormData && init.body.has('sections');
      p.then(function (r) {
        if (!r || !r.ok || themeHandled) return;
        window.__pzJustAdded = true;
        try { sessionStorage.setItem('pz_open_cart', String(Date.now())); } catch (e) {}
        setTimeout(function () { window.__pzJustAdded = false; }, 8000);
        if (injected) {
          window.__pzApplyP = r.clone().json().then(function (j) {
            if (j && j.sections) applySections(j.sections);
            var d = drawerEl();
            if (d && typeof d.open === 'function') { d.open(); try { sessionStorage.removeItem('pz_open_cart'); } catch (e) {} }
          }).catch(function () {}).then(function () { setTimeout(function () { window.__pzApplyP = null; }, 3000); });
        }
      }).catch(function () {});
    }
    return p;
  };

  // Builder pages jump to /cart after adding; show the drawer instead (Chromium). Others fall back below.
  if (window.navigation && window.navigation.addEventListener) {
    window.navigation.addEventListener('navigate', function (e) {
      if (!window.__pzJustAdded || !e.cancelable) return;
      var u; try { u = new URL(e.destination.url); } catch (x) { return; }
      if (u.origin === location.origin && /^\/cart\/?$/.test(u.pathname)) {
        window.__pzJustAdded = false;
        try { sessionStorage.removeItem('pz_open_cart'); } catch (x) {}
        e.preventDefault();
        window.pzOpenCart();
      }
    });
  }

  function pendingOpen() {
    var t = 0;
    try { t = +sessionStorage.getItem('pz_open_cart') || 0; } catch (e) {}
    return t && Date.now() - t < 20000;
  }
  function onShow(ev) {
    if (ev && ev.persisted) refresh();
    if (!pendingOpen()) return;
    if (/^\/cart\/?$/.test(location.pathname)) {
      if (document.referrer && document.referrer.indexOf(location.origin) === 0 && !/\/cart/.test(document.referrer) && history.length > 1) history.back();
      return;
    }
    try { sessionStorage.removeItem('pz_open_cart'); } catch (e) {}
    window.pzOpenCart();
  }
  window.addEventListener('pageshow', onShow);

  function start() { fixEmpty(); watch(); sync(); onShow(); scheduleExpressCheck(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  // Free glue dots option: saved as a cart attribute so it shows on the order
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'pz-glue') {
      post('/cart/update.js', { attributes: { 'Free glue dots': e.target.checked ? 'Yes' : 'No' } }).catch(function () {});
    }
  });

  function shake() {
    var tl = $('.pz-terms');
    if (tl) { tl.classList.remove('pz-shake'); void tl.offsetWidth; tl.classList.add('pz-shake'); }
  }
  function waitIdle(ms) {
    var t0 = Date.now();
    return new Promise(function (res) {
      (function tick() {
        if ((!window.__pzBusy && !$('[data-pz-pending]')) || Date.now() - t0 > ms) return res();
        setTimeout(tick, 100);
      })();
    });
  }

  // Delegated clicks: wall preview lightbox, terms check, checkout waits for gifts to finish adding
  document.addEventListener('click', function (e) {
    var tgt = e.target;
    var see = tgt.closest && tgt.closest('[data-pz-see]');
    if (see) {
      var box = document.createElement('div');
      box.className = 'pz-lightbox';
      box.innerHTML = '<img alt="Your wall" src="' + see.getAttribute('data-pz-see') + '">';
      box.addEventListener('click', function () { box.remove(); });
      document.body.appendChild(box);
      return;
    }
    if (tgt.closest && tgt.closest('[data-pz-lock]')) {
      var tc = document.getElementById('pz-terms');
      if (tc && !tc.checked) shake();
      return;
    }
    var co = tgt.closest && tgt.closest('#CartDrawer-Checkout, #checkout');
    if (co && co.type === 'submit') {
      var t = document.getElementById('pz-terms');
      if (t && !t.checked) { e.preventDefault(); shake(); return; }
      // Buy now goes straight to Shopify's checkout. If the cart is still updating, wait for it first, then submit the cart form.
      if (window.__pzBusy || $('[data-pz-pending]')) {
        e.preventDefault();
        var label = co.textContent;
        co.textContent = 'One moment…';
        waitIdle(8000).then(function () {
          co.textContent = label;
          var f = co.form;
          if (f && f.requestSubmit) f.requestSubmit(co); else if (f) f.submit();
        });
      }
    }
  }, true);
  // Coupon box (drawer and /cart page). Shopify's cart update takes one "discount" code; an empty string clears it.
  function couponMsg(root, text, kind) {
    var m = root && root.querySelector('[data-pz-coupon-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.className = 'pz-coupon__msg' + (text ? ' is-' + (kind || 'err') : '');
  }
  function couponSet(root, code) {
    if (!root || root.__pzBusy) return Promise.resolve();
    root.__pzBusy = true;
    var inDrawer = !!(root.closest && root.closest('cart-drawer'));
    var body = { discount: code };
    if (inDrawer) body.sections = SECTIONS;
    var btns = root.querySelectorAll('button');
    btns.forEach(function (b) { b.disabled = true; });
    couponMsg(root, code ? 'Checking code…' : '', 'ok');
    function fail(text) {
      root.__pzBusy = false;
      btns.forEach(function (b) { b.disabled = false; });
      couponMsg(root, text, 'err');
    }
    return post('/cart/update.js', body)
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.j) { fail('Could not apply the code. Please try again.'); return; }
        var j = res.j;
        if (code) {
          var hit = (j.discount_codes || []).filter(function (d) { return d.code && d.code.toLowerCase() === code.toLowerCase(); })[0];
          if (!hit || !hit.applicable) {
            // Not valid for this cart: clear it so a stale code is never carried to checkout.
            return post('/cart/update.js', { discount: '' }).catch(function () {}).then(function () {
              fail("That code can't be used on this cart. Check the spelling, the expiry date and any minimum order. Some codes can't be combined with other offers.");
            });
          }
        }
        if (inDrawer) {
          applySections(j.sections);
          var r2 = $('[data-pz-coupon]');
          if (code && r2 && !r2.querySelector('.pz-coupon__chip')) {
            var dt = r2.querySelector('details'); if (dt) dt.open = true;
            couponMsg(r2, 'Code ' + code.toUpperCase() + ' added. It will be applied at checkout.', 'ok');
          }
        } else {
          location.reload();
        }
      })
      .catch(function () { fail('Could not apply the code. Please try again.'); })
      .then(function () { root.__pzBusy = false; });
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var ap = t.closest('[data-pz-coupon-apply]');
    if (ap) {
      e.preventDefault();
      var root = ap.closest('[data-pz-coupon]');
      var inp = root && root.querySelector('[data-pz-coupon-input]');
      var v = ((inp && inp.value) || '').replace(/\s+/g, '');
      if (!v) { couponMsg(root, 'Enter a coupon code.', 'err'); return; }
      couponSet(root, v);
      return;
    }
    var rm = t.closest('[data-pz-coupon-remove]');
    if (rm) { e.preventDefault(); couponSet(rm.closest('[data-pz-coupon]'), ''); }
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key === 'Enter' && t && t.matches && t.matches('[data-pz-coupon-input]')) {
      e.preventDefault();
      var b = t.closest('[data-pz-coupon]').querySelector('[data-pz-coupon-apply]');
      if (b) b.click();
    }
  });

})();
